// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dunsparce: PokeData = {
  "id": 206,
  "name": "dunsparce",
  "height": 15,
  "weight": 140,
  "base_experience": 145,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "body-slam",
    "take-down",
    "double-edge",
    "dig",
    "rage",
    "screech",
    "defense-curl",
    "glare",
    "flail",
    "spite",
    "mud-slap",
    "endure",
    "rollout",
    "pursuit",
    "ancient-power",
    "yawn",
    "endeavor",
    "roost",
    "air-slash",
    "dragon-rush",
    "coil",
    "drill-run",
    "hyper-drill"
  ],
  "moves": [
    "body-slam",
    "mud-slap",
    "pursuit",
    "ancient-power",
    "roost",
    "air-slash",
    "dragon-rush",
    "scary-face",
    "leer",
    "tri-attack",
    "scratch",
    "splash",
    "refresh"
  ],
  "evolution_chain": {
    "id": 103,
    "item": null,
    "species": [
      {
        "name": "dunsparce",
        "order": 237,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dudunsparce",
        "order": 917,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 206,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "hyper-drill"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 83.75,
    "speed": 45,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
